import { globalStateCTX } from '../../../GlobalState/GlobalState';
import { useNonce } from '../../../Utils/hooks';
import NumberFormater from '../../NumberFormater/NumberFormater';
import KpiCard, { KPISize, KPIStatus } from '../../KPIs/KPICard/KpiCard';
import React from 'react';
import { statisticsApi } from '../../../Http/Http';
import { useTranslation } from 'react-i18next';
import { FilterValuesType } from '../../../FiltersProvider/FiltersProvider';

interface Props {
  filterValues?: FilterValuesType;
  propertyId?: number;
}

const ParkingLeaseCountKpi: React.FC<Props> = (props) => {
  const { t } = useTranslation(['contracts', 'common']);
  const { handleHttpErrors } = React.useContext(globalStateCTX);

  const [occupiedLeasesCount, setOccupiedLeasesCount] = React.useState<number>();
  const [totalLeasesCount, setTotalLeasesCount] = React.useState<number>();
  const [status, setStatus] = React.useState<KPIStatus>(KPIStatus.Loading);
  const [shouldReload, reload] = useNonce();

  React.useEffect(() => {
    const abortController = new AbortController();

    const load = async () => {
      try {
        setStatus(KPIStatus.Loading);
        const { data } = await statisticsApi.statisticsResourceGetParking(
          {
            ...props.filterValues,
            propertyId: props.propertyId
          },
          {
            signal: abortController.signal
          }
        );

        setOccupiedLeasesCount(data.active);
        setTotalLeasesCount(data.active + data.vacant);
        setStatus(KPIStatus.None);
      } catch (error) {
        handleHttpErrors(error) && setStatus(KPIStatus.LoadError);
      }
    };
    load();

    return () => abortController.abort();
  }, [props.filterValues, props.propertyId, handleHttpErrors, shouldReload]);

  return (
    <KpiCard
      title={t('contracts:parkingSpots')}
      valueAs="h5"
      value={
        totalLeasesCount != null && totalLeasesCount !== 0 ? (
          <span>
            <NumberFormater value={occupiedLeasesCount} />/
            <NumberFormater value={totalLeasesCount} />
          </span>
        ) : (
          t('contracts:noParkingSpots')
        )
      }
      status={status}
      retry={reload}
      size={KPISize.small}
    />
  );
};

export default ParkingLeaseCountKpi;
